import { render, staticRenderFns } from "./TeamOrders.vue?vue&type=template&id=8eebd4c8&scoped=true&"
import script from "./TeamOrders.vue?vue&type=script&lang=js&"
export * from "./TeamOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eebd4c8",
  null
  
)

export default component.exports